module.exports = __webpack_public_path__ + "img/icon_veiw.cd17c5c8.svg";